import type { PasswordHashResult } from '@/services/abstract/poc/crypto.service.interface';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const calculateHashThunk = createAppAsyncThunk<PasswordHashResult>(
  'pocAuth/calculateHash',
  async(_, { extra: { pocServices }, getState, rejectWithValue }) => {
    const {
      pocAuth: { password, email },
    } = getState();

    try {
      return await pocServices.cryptoService.hashPassword(password, email);
    } catch (error) {
      return rejectWithValue({
        message: `Error generating hash: ${error instanceof Error ? error.message : String(error)}`,
      });
    }
  }
);
